export const loadScript = (url, onload) => {
  const script = document.createElement("script");
  script.onerror = (err) => {
    throw new URIError(`${err.target.src} failed to load`);
  };
  script.onload = onload;
  document.body.appendChild(script);
  script.src = url;
};
